import type { Column } from "@tanstack/react-table"
import type { ColumnFilterConfig } from "../table.types"
import { getColumnTitle } from "../table.utils"
import TableFilterInput from "./TableFilterInput"

export type TableFilterRowProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  column: Column<any, any>
}

function TableFilterRow(props: TableFilterRowProps) {
  const { column } = props
  const meta = column.columnDef.meta as
    | { filter?: ColumnFilterConfig }
    | undefined

  const filterConfig = meta?.filter
  if (!filterConfig) return null

  const filterValue = column.getFilterValue()
  const title = getColumnTitle(column)

  return (
    <div className="ui-table-filter-row">
      <label className="ui-table-filter-row-label">{title}</label>
      <TableFilterInput
        filter={filterConfig}
        value={filterValue}
        onChange={(value) => {
          column.setFilterValue(value)
        }}
      />
    </div>
  )
}

export default TableFilterRow
